import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Phone } from '@mui/icons-material';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  placeholder = 'e.g., +91 9876543210',
  error = false,
  helperText,
  disabled = false,
  required = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // Only allow numbers, + sign, and spaces
    const sanitizedValue = inputValue.replace(/[^\d+\s]/g, '');
    onChange(sanitizedValue);
  };

  return (
    <TextField
      fullWidth
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Phone sx={{ fontSize: 20, color: 'action.active' }} />
          </InputAdornment>
        ),
      }}
    />
  );
};
